import { t } from "@/i18n-js/instance";
import { EmailHubFreePeriodBanner } from "@/react/components/shared/EmailHubFreePeriodBanner";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { useEmailHubBilling } from "@circle-react/hooks/useEmailHubBilling";
import { useIsEmailHubStatusEnabled } from "@circle-react/hooks/useIsEmailHubStatus";
import { NavGroup } from "../NavGroup";
import { FooterWrapper } from "./FooterWrapper";
import { SubNavLinkItem } from "./SubNavLinkItem";
import type { Link } from "./types";

const i18nRoot = "settings_nav_v3.emails";

export const EmailLinks = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const { isInFreePeriod } = useEmailHubBilling();
  const isEmailHubStatusEnabled = useIsEmailHubStatusEnabled();

  const links: Link[] = [
    {
      label: t([i18nRoot, "overview"]),
      path: settingsNavPathV3.email.overview,
      exact: true,
      isDisabled: !isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t([i18nRoot, "broadcasts"]),
      path: settingsNavPathV3.email.broadcast,
      exact: true,
      isDisabled: !isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t([i18nRoot, "forms"]),
      path: settingsNavPathV3.email.forms,
      exact: true,
      isDisabled: !isCommunityAdmin(currentCommunityMember),
    },
    {
      label: t([i18nRoot, "settings"]),
      path: settingsNavPathV3.email.settings,
      isDisabled:
        !isEmailHubStatusEnabled || !isCommunityAdmin(currentCommunityMember),
      exact: true,
    },
  ].filter(Boolean) as Link[];

  return (
    <NavGroup groupLinks={links}>
      <NavGroup.Content title={t([i18nRoot, "title"])}>
        {links.map(link => (
          <SubNavLinkItem
            key={link.path}
            label={link.label}
            path={link.path}
            isDisabled={link.isDisabled}
          />
        ))}
        {isInFreePeriod && (
          <FooterWrapper>
            <EmailHubFreePeriodBanner />
          </FooterWrapper>
        )}
      </NavGroup.Content>
    </NavGroup>
  );
};
